import FocusBearLogoAnimated from 'assets/icons/FocusBearLogoAnimated';
import quotes from 'constants/quotes';
import { ATTRIB } from 'constants/test';
import { t } from 'services/i18n.service';
import { useMemo } from 'react';

interface Props {
  readonly title?: string;
  icon?: JSX.Element;
}

const MotivationalLoading = ({
  icon = <FocusBearLogoAnimated className='~w-24/44 ~h-24/44' />,
  title
}: Props) => {
  const randomQuote = useMemo(() => {
    const index = Math.floor(Math.random() * quotes.length);
    return quotes[index];
  }, []);

  return (
    <section
      data-testid={ATTRIB.DATA_TESTID.LOADING_SCREEN}
      className='w-full h-full flex flex-col justify-center items-center ~gap-5/16 animate-fadeIn bg-secondary-50 dark:bg-secondary-dark-200 dark:text-secondary-dark-900 text-primary-900 ~p-4/10'>
      {icon}
      <h1 className='w-fit h-fit animate-pulse text-center text-inherit'>
        {title ?? t('lazy_load_placeholder.focus_bear_is_waking_up')}
      </h1>
      <blockquote className='mt-2 max-w-[720px] text-center italic opacity-90 ~text-sm/lg dark:opacity-100 dark:text-secondary-dark-800'>
        <p>{randomQuote.quote}</p>
        <footer className='mt-1 not-italic opacity-70 dark:opacity-90 dark:text-secondary-dark-700'>
          {randomQuote.author}
        </footer>
      </blockquote>
    </section>
  );
};

export default MotivationalLoading;
